import React, { useEffect, useState } from "react";
import "./header.scss";
import { connect } from "react-redux";
import LabelInput from "../../../atoms/label";
import ProgressBar from "../../../atoms/progressBar";
import { Box, Container, Modal, Typography } from "@mui/material";
import { useLocation, useNavigate } from "react-router";
import { getSurveyList } from "../../../redux/action/user";
import ButtonInput from "../../../atoms/button";
import WarningIcon from "@mui/icons-material/Warning";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "600px",
  bgcolor: "#fff",
  border: "2px solid #000",
  borderRadius: "10px",
  boxShadow: 24,
  p: 4,
};

const ProgressHeader = (props) => {
  const [progress, setProgress] = useState(0);
  const [answredGroup, setAnsworGroup] = useState(0);
  const [warningModal, setWarningModal] = useState({
    show: false,
    navigate: "",
  });
  const navigate = useNavigate();
  const location = useLocation()

  useEffect(() => {
    props.getSurveyList();
  }, []);

  useEffect(() => {
    if (props.user?.totalDetermine.length > 0) {
      const answedDetermin = props.user?.totalDetermine.filter(
        (obj) => obj.isFillUp === true
      ).length;
      if (props.user?.totalDetermine.length > answedDetermin) {
        const progrsss =
          ((answedDetermin + 1) / props.user?.totalDetermine.length) * 100;
        setAnsworGroup(answedDetermin + 1);
        setProgress(progrsss);
      } else {
        setAnsworGroup(props.user?.totalDetermine.length);
        setProgress(100);
      }
    }
  }, [props.user?.totalDetermine, location.pathname]);


  return (
    <div className="progress-header-section" style={{ background: 'white' }}>
      <Container>
        {localStorage.getItem("review") === null && (
          <div className="progress-header-section__body-header" style={{ marginTop: '10px' }}>
            <div className="gridContainer" style={{ width: '100%', marginLeft: '0px', marginRight: '0px' }}>
              <div className="inner-progress-header__fixed--bottom">
                <h3 className="inner-progress-header__fixed--bottom--left">
                  <LabelInput
                    text={props.user.language?.questionList?.title + " : "}
                    className={"header-title"}
                  />
                  <LabelInput
                    className={"header-title"}
                    text={props.user?.activeGroup || ""}
                  />
                </h3>
                <div className="inner-progress-header__fixed--bottom--right">
                  {props.user?.questionList?.length > 0 && (
                    <>
                      <div className="left-side-progress">
                        <ProgressBar progressValue={progress} />
                      </div>
                      <h4 style={{ display: "flex", marginLeft: "10px" }}>
                        <LabelInput
                          className={"header-title"}
                          text={`${answredGroup > 9 ? answredGroup : "0" + answredGroup
                            }`}
                        />
                      </h4>
                      <LabelInput
                        className={"header-title"}
                        text={`/${props.user?.totalDetermine?.length > 9
                          ? props.user?.totalDetermine?.length
                          : "0" + props.user?.totalDetermine?.length
                          } ${props.user.language?.questionList?.sections}`}
                      />
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </Container>
      <Modal open={warningModal.show}>
        <Box sx={style}>
          <div>
            <Box
              sx={{
                textAlign: "center",
                svg: {
                  height: "50px",
                  width: "50px",
                  path: {
                    fill: "#c90a0a",
                  },
                },
              }}
            >
              <WarningIcon />
            </Box>

            <Typography sx={{ textAlign: "justify" }}>
              You are about to leave this assessment, your progress will be
              saved for later. If you leave, you can navigate to ‘Assessments’
              and select ‘view’ to resume.
            </Typography>
            {/* <Typography>Do you wish to proceed ?</Typography> */}

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                button: {
                  "&.MuiButtonBase-root": {
                    "&.MuiButton-root": {
                      padding: "5px 10px !important",
                      height: "unset !important",
                      borderRadius: "6px !important",
                      backgroundColor: "#faaa2f !important",
                      color: "#fff !important",
                      "&:nth-of-type(1)": {
                        mr: "10px !important",
                      },
                    },
                  },
                },
              }}
            >
              <ButtonInput
                // class="modal-button"
                text="Finish later"
                onSubmit={() =>
                  warningModal.navigate && navigate(warningModal.navigate)
                }
              />
              <ButtonInput
                // class="modal-button"
                text="Finish now"
                onSubmit={() => setWarningModal({ show: false, navigate: "" })}
              />
            </Box>
          </div>
        </Box>
      </Modal>
    </div>
  );
};

ProgressHeader.propTypes = {};
ProgressHeader.defaultProps = {};

const actionCreators = {
  getSurveyList,
};

export default connect(
  ({ user }) => ({
    user,
  }),
  actionCreators
)(ProgressHeader);
